var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#59D8B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5h-1v1h1v-1z",
    fill: "#020002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H6V6.5h11v-1H6a1 1 0 0 0-1 1V17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM6 17V9h12v1.5h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4V17H6zm12-5.5v3h-4v-3h4z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsActiveIcon);
export default __webpack_public_path__ + "static/media/paymentsActiveIcon.ce711a31376260e925752dd2fa4de66a.svg";
export { ForwardRef as ReactComponent };